module.exports = __webpack_public_path__ + "static/boids-8c05fdc05def4bf24f4c040318b79139.png";